import { AxiosResponse } from "axios";
import { IMapMarker, IMapMarkersRes } from "../fields/boomtypes";
import { IField, IFieldResponseData } from "./../fields/types";
import { ActionType } from "./../types/store-types";

export interface IMarker {
    marker: {
        location: string;
        description: string;
        geometry: {
            lat: number;
            lng: number;
        };
    };
}

interface IInitalMarkerData {
    fieldId: IField["_id"];
}

interface IFailureMarkers {
    fieldId: IField["_id"];
}

interface IInitMarkersData {
    list: IFieldResponseData[];
}

interface IAddMarkerData {
    fieldId: IField["_id"];
    markerData: IMarker;
    markerId?: string;
}
interface IAddMarkerSuccessData {
    fieldId: IField["_id"];
    markers: IMapMarker[];
}

interface IDeleteMarkerData {
    fieldId: IField["_id"];
    markerId: string;
}
interface IDeleteMarkerSuccessData {
    fieldId: IField["_id"];
    markers: IMapMarker[];
}

interface IUpdateMarkerData {
    fieldId: IField["_id"];
    markerId: string;
    markerData: IMarker;
}
interface IUpdateMarkerSuccessData {
    fieldId: IField["_id"];
    markers: IMapMarker[];
}

export interface IMarkerState {
    location: string;
    description: string;
    geometry: {
        lat: number;
        lng: number;
    };
}

export interface IMarkersState {
    [id: string]: IMarkerState;
}

export interface IMapMarkersState {
    [id: string]: IMarkersState;
}

export type markersResponse = AxiosResponse<{
    success: boolean;
    message: string;
    data: IMapMarkersRes;
}>;

export enum MarkersActionTypes {
    INIT_MARKERS = "MARKERS.INIT_MARKERS",

    INITAL_MARKER = "MARKERS.INITAL_MARKER",

    ADD_MARKER_REQUEST = "MARKERS.ADD_MARKER_REQUEST",
    ADD_MARKER_SUCCESS = "MARKERS.ADD_MARKER_SUCCESS",
    ADD_MARKER_FAILURE = "MARKERS.ADD_MARKER_FAILURE",

    DELETE_MARKER_REQUEST = "MARKERS.DELETE_MARKER_REQUEST",
    DELETE_MARKER_SUCCESS = "MARKERS.DELETE_MARKER_SUCCESS",
    DELETE_MARKER_FAILURE = "MARKERS.DELETE_MARKER_FAILURE",

    UPDATE_MARKER_REQUEST = "MARKERS.UPDATE_MARKER_REQUEST",
    UPDATE_MARKER_SUCCESS = "MARKERS.UPDATE_MARKER_SUCCESS",
    UPDATE_MARKER_FAILURE = "MARKERS.UPDATE_MARKER_FAILURE",
}

export type InitalMarkerActionType = ActionType<MarkersActionTypes.INITAL_MARKER, IInitalMarkerData>;

export type InitMarkersActionType = ActionType<MarkersActionTypes.INIT_MARKERS, IInitMarkersData>;

export type AddMarkerRequestActionType = ActionType<MarkersActionTypes.ADD_MARKER_REQUEST, IAddMarkerData>;
export type AddMarkerSuccessActionType = ActionType<MarkersActionTypes.ADD_MARKER_SUCCESS, IAddMarkerSuccessData>;
export type AddMarkerFailureActionType = ActionType<MarkersActionTypes.ADD_MARKER_FAILURE, IFailureMarkers>;

export type DeleteMarkerRequestActionType = ActionType<MarkersActionTypes.DELETE_MARKER_REQUEST, IDeleteMarkerData>;
export type DeleteMarkerSuccessActionType = ActionType<
    MarkersActionTypes.DELETE_MARKER_SUCCESS,
    IDeleteMarkerSuccessData
>;
export type DeleteMarkerFailureActionType = ActionType<MarkersActionTypes.DELETE_MARKER_FAILURE, IFailureMarkers>;

export type UpdateMarkerRequestActionType = ActionType<MarkersActionTypes.UPDATE_MARKER_REQUEST, IUpdateMarkerData>;
export type UpdateMarkerSuccessActionType = ActionType<
    MarkersActionTypes.UPDATE_MARKER_SUCCESS,
    IUpdateMarkerSuccessData
>;
export type UpdateMarkerFailureActionType = ActionType<MarkersActionTypes.UPDATE_MARKER_FAILURE, IFailureMarkers>;
